import { RouteConfig } from 'vue-router';
import { RouteName } from '../routes.constants';
import { authenticationGuard, AuthRestriction } from '../../services';
import { getAccountComponent } from '../account/account.constants';

export const LandingV2Routes: RouteConfig[] = [
    {
        name: RouteName.LANDING,
        path: ':slug',
        component: getAccountComponent('LandingV2Page'),
        meta: {
            shouldHideMainMenu: false,
            ...authenticationGuard(AuthRestriction.AUTH_FORBIDDEN),
        },
    },
    {
        name: RouteName.LANDING_SIGNUP,
        path: ':slug/:step',
        component: getAccountComponent('LandingV2Page'),
        meta: {
            shouldHideMainMenu: false,
            ...authenticationGuard(AuthRestriction.AUTH_FORBIDDEN),
        },
    },
];
